import { _ as Le } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.date.to-string-6ed49878.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.object.to-string-f55666a8.js";
import "./es.parse-float-020a2ae0.js";
import "./es.parse-int-d7709701.js";
import "./es.regexp.to-string-e800d529.js";
import "./web.set-timeout-72b6430f.js";
import { QUERIES as ue, useTheme as Ne } from "@ucl/shared-component-foundations";
import { fordProIcons as v } from "@ucl/shared-icons";
import { useState as s, useRef as C, useEffect as Fe } from "react";
import d from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as $e } from "./getMetrics-953aa4f8.js";
import { useAccessibilityProps as m } from "./accessibility.js";
import "./es.array.join-c1bca812.js";
import "./es.regexp.constructor-6da4b85c.js";
import "./es.global-this-a7f40ce1.js";
import { jsxs as c, jsx as r } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./classof-21a3574e.js";
import "./to-string-92a62764.js";
import "./string-trim-14e37ad3.js";
import "./function-apply-4756dee6.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.object.keys-9d66766f.js";
import "./inherit-if-required-f068457b.js";
import "./set-species-5ede2ed0.js";
import "./define-built-in-accessor-26bc7b69.js";
var He = ["src", "isMuted", "shouldAutoPlay", "shouldLoop", "subtitlesOnByDefault", "children", "onTimeUpdate", "onEnded", "onPlay", "onPause", "onLoadedMetadata", "onProgress", "accessibilityOptions"], Ke = v.ClosedCaptions, qe = v.Expand, Qe = v.Mute, Xe = v.Pause, Ge = v.PlayFilled, Je = v.ShareAndroid, Ye = v.Volume, Ze = /* @__PURE__ */ d.div.withConfig({
  displayName: "videoPlayer__VideoPlayerContainer",
  componentId: "sc-12lazjv-0"
})(["--thumbSize:", ";--volumeBarWidth:", ";display:", ";position:", ";max-width:", ";max-height:", ";video::-webkit-media-controls{display:", " !important;}&:hover{div{opacity:", ";}}"], function(e) {
  return e.theme.components.videoPlayer.VideoPlayerContainer["--thumbSize"];
}, function(e) {
  return e.theme.components.videoPlayer.VideoPlayerContainer["--volumeBarWidth"];
}, function(e) {
  return e.theme.components.videoPlayer.VideoPlayerContainer.display;
}, function(e) {
  return e.theme.components.videoPlayer.VideoPlayerContainer.position;
}, function(e) {
  return e.theme.components.videoPlayer.VideoPlayerContainer.maxWidth;
}, function(e) {
  return e.theme.components.videoPlayer.VideoPlayerContainer.maxHeight;
}, function(e) {
  return e.theme.components.videoPlayer.VideoPlayerContainer.video.webkitMediaControls.display;
}, function(e) {
  return e.theme.components.videoPlayer.VideoPlayerContainer.hover.div.opacity;
}), et = /* @__PURE__ */ d.video.withConfig({
  displayName: "videoPlayer__VideoPlayerElement",
  componentId: "sc-12lazjv-1"
})(["max-width:", ";max-height:", ";"], function(e) {
  return e.theme.components.videoPlayer.VideoPlayerElement.maxWidth;
}, function(e) {
  return e.theme.components.videoPlayer.VideoPlayerElement.maxHeight;
}), tt = /* @__PURE__ */ d.div.withConfig({
  displayName: "videoPlayer__VideoControls",
  componentId: "sc-12lazjv-2"
})(["opacity:", ";overflow:", ";transition:", ";position:", ";bottom:", ";left:", ";right:", ";background-color:", ";color:", ";display:", ";justify-content:", ";align-items:", ";padding:", ";flex-direction:", ";&:focus-within{opacity:", ";}"], function(e) {
  return e.theme.components.videoPlayer.VideoControls.opacity;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.overflow;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.transition;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.position;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.bottom;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.left;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.right;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.backgroundColor;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.color;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.display;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.justifyContent;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.alignItems;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.padding;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.flexDirection;
}, function(e) {
  return e.theme.components.videoPlayer.VideoControls.focusWithin.opacity;
}), f = /* @__PURE__ */ d.button.withConfig({
  displayName: "videoPlayer__ButtonElement",
  componentId: "sc-12lazjv-3"
})(["background-color:", ";border:", ";color:", ";margin-right:", ";padding:", ";display:", ";align-items:", ";justify-content:", ";&:not(:disabled){cursor:", ";&:hover{background-color:", ";border-radius:", ";}&:focus-visible{outline:", ";box-shadow:", ";border-radius:", ";}}& > svg{width:", ";height:", ";}&:disabled{color:", ";}"], function(e) {
  return e.theme.components.videoPlayer.ButtonElement.backgroundColor;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.border;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.color;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.marginRight;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.padding;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.display;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.alignItems;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.justifyContent;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.notDisabled.cursor;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.notDisabled.hover.backgroundColor;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.notDisabled.hover.borderRadius;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.notDisabled.focusVisible.outline;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.notDisabled.focusVisible.boxShadow;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.notDisabled.focusVisible.borderRadius;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.svg.width;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.svg.height;
}, function(e) {
  return e.theme.components.videoPlayer.ButtonElement.disabled.color;
}), ot = /* @__PURE__ */ d(f).withConfig({
  displayName: "videoPlayer__SubtitlesButton",
  componentId: "sc-12lazjv-4"
})(["border-bottom:", ";padding:", ";&:not(:disabled){", "}"], function(e) {
  return e.theme.components.videoPlayer.SubtitlesButton.borderBottom;
}, function(e) {
  return e.theme.components.videoPlayer.SubtitlesButton.padding;
}, function(e) {
  return e.showSubtitles ? `
        border-bottom: ` + e.theme.components.videoPlayer.SubtitlesButton.notDisabled.showSubtitles.borderBottom + `;
        border-bottom-left-radius: ` + e.theme.components.videoPlayer.SubtitlesButton.notDisabled.showSubtitles.borderBottomLeftRadius + ` !important;
        border-bottom-right-radius: ` + e.theme.components.videoPlayer.SubtitlesButton.notDisabled.showSubtitles.borderBottomRightRadius + ` !important;
      ` : "";
}), nt = /* @__PURE__ */ d.div.withConfig({
  displayName: "videoPlayer__ProgressBar",
  componentId: "sc-12lazjv-5"
})(["position:", ";width:", ";height:", ";overflow:", ";margin-bottom:", ";background:", ";border-radius:", ";cursor:", ";&:focus-visible{outline:", ";outline-offset:", ";}& > div{position:", ";top:", ";left:", ";height:", ";border-radius:", ";width:", ";transition:", ";&:nth-of-type(1){background:", ";z-index:", ";}&:nth-of-type(2){background:", ";}}"], function(e) {
  return e.theme.components.videoPlayer.ProgressBar.position;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.width;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.height;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.overflow;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.marginBottom;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.background;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.borderRadius;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.cursor;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.focusVisible.outline;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.focusVisible.outlineOffset;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.position;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.top;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.left;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.height;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.borderRadius;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.width;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.transition;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.nthOfType1.background;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.nthOfType1.zIndex;
}, function(e) {
  return e.theme.components.videoPlayer.ProgressBar.div.nthOfType2.background;
}), rt = /* @__PURE__ */ d.div.withConfig({
  displayName: "videoPlayer__VideoButtonsContainer",
  componentId: "sc-12lazjv-6"
})(["display:", ";flex-direction:", ";width:", ";justify-content:", ";"], function(e) {
  return e.theme.components.videoPlayer.VideoButtonsContainer.display;
}, function(e) {
  return e.theme.components.videoPlayer.VideoButtonsContainer.flexDirection;
}, function(e) {
  return e.theme.components.videoPlayer.VideoButtonsContainer.width;
}, function(e) {
  return e.theme.components.videoPlayer.VideoButtonsContainer.justifyContent;
}), le = /* @__PURE__ */ d.div.withConfig({
  displayName: "videoPlayer__VideoButtonsSection",
  componentId: "sc-12lazjv-7"
})(["display:", ";flex-direction:", ";align-items:", ";"], function(e) {
  return e.theme.components.videoPlayer.VideoButtonsSection.display;
}, function(e) {
  return e.theme.components.videoPlayer.VideoButtonsSection.flexDirection;
}, function(e) {
  return e.theme.components.videoPlayer.VideoButtonsSection.alignItems;
}), it = /* @__PURE__ */ d.div.withConfig({
  displayName: "videoPlayer__TimeContainer",
  componentId: "sc-12lazjv-8"
})(["display:", ";align-items:", ";font-family:", ";font-style:", ";font-weight:", ";font-size:", ";line-height:", ";color:", ";"], function(e) {
  return e.theme.components.videoPlayer.TimeContainer.display;
}, function(e) {
  return e.theme.components.videoPlayer.TimeContainer.alignItems;
}, function(e) {
  return e.theme.components.videoPlayer.TimeContainer.fontFamily;
}, function(e) {
  return e.theme.components.videoPlayer.TimeContainer.fontStyle;
}, function(e) {
  return e.theme.components.videoPlayer.TimeContainer.fontWeight;
}, function(e) {
  return e.theme.components.videoPlayer.TimeContainer.fontSize;
}, function(e) {
  return e.theme.components.videoPlayer.TimeContainer.lineHeight;
}, function(e) {
  return e.theme.components.videoPlayer.TimeContainer.color;
}), at = /* @__PURE__ */ d.input.withConfig({
  displayName: "videoPlayer__VolumeBar",
  componentId: "sc-12lazjv-9"
})(["-webkit-appearance:", ";max-width:", ";width:", ";height:", ";transition:", ";background:", ";cursor:", ";margin-right:", ";&::-webkit-slider-thumb{-webkit-appearance:", ";border-radius:", ";cursor:", ";width:", ";height:", ";transition:", ";background:", ";border:", ";}&::-moz-range-thumb{-webkit-appearance:", ";border-radius:", ";cursor:", ";width:", ";height:", ";transition:", ";background:", ";border:", ";}&:focus{outline:", ";}@media ", " and (hover:hover){&:focus-visible{outline:", ";outline-offset:", ";width:", ";max-width:", ";margin-right:", ";border-radius:", ";&::-webkit-slider-thumb{width:", ";height:", ";}&::-moz-range-thumb{width:", ";height:", ";}}}"], function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitAppearance;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.maxWidth;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.height;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.transition;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.background;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.cursor;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.marginRight;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.WebkitAppearance;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.borderRadius;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.cursor;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.height;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.transition;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.background;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.webkitSliderThumb.border;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.webkitAppearance;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.borderRadius;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.cursor;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.height;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.transition;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.background;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.mozRangeThumb.border;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.focus.outline;
}, ue.tabletAndUp, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.outline;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.outlineOffset;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.maxWidth;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.marginRight;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.borderRadius;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.webkitSliderThumb.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.webkitSliderThumb.height;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.mozRangeThumb.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeBar.tabletAndUp.hover.focusVisible.mozRangeThumb.height;
}), lt = /* @__PURE__ */ d.div.withConfig({
  displayName: "videoPlayer__VolumeContainer",
  componentId: "sc-12lazjv-10"
})(["display:", ";align-items:", ";@media ", " and (hover:hover){&:hover{input[type='range']{width:", ";max-width:", ";margin-right:", ";&::-webkit-slider-thumb{width:", ";height:", ";}&::-moz-range-thumb{width:", ";height:", ";}}}}"], function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.display;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.alignItems;
}, ue.tabletAndUp, function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.maxWidth;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.marginRight;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.webkitSliderThumb.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.webkitSliderThumb.height;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.mozRangeThumb.width;
}, function(e) {
  return e.theme.components.videoPlayer.VolumeContainer.tabletAndUp.hover.inputTypeRange.mozRangeThumb.height;
});
function io(e) {
  var x, A, I, j = e.src, O = e.isMuted, de = O === void 0 ? !1 : O, z = e.shouldAutoPlay, se = z === void 0 ? !1 : z, _ = e.shouldLoop, me = _ === void 0 ? !1 : _, U = e.subtitlesOnByDefault, ce = U === void 0 ? !1 : U, he = e.children, D = e.onTimeUpdate, M = e.onEnded, W = e.onPlay, L = e.onPause, N = e.onLoadedMetadata, F = e.onProgress, a = e.accessibilityOptions, ve = Le(e, He), pe = $e({
    label: "VideoPlayer"
  }), $ = s(!1), w = $[0], T = $[1], H = s(ce), y = H[0], fe = H[1], K = s(!1), q = K[0], ye = K[1], Q = s(0), Pe = Q[0], X = Q[1], G = s(0), P = G[0], b = G[1], J = s(de ? 0 : 1), g = J[0], Y = J[1], Z = s(1), ee = Z[0], be = Z[1], te = s(-1), B = te[0], V = te[1], oe = s("0:00"), ge = oe[0], Be = oe[1], n = C(null), S = C(null), k = C(null), R = C(null), h = Ne();
  function E() {
    var t = n == null ? void 0 : n.current;
    w ? t.pause() : t.play();
  }
  function Ve() {
    T(!1), clearInterval(B), V(-1), M == null || M();
  }
  function Ce() {
    var t = n == null ? void 0 : n.current;
    if (Be(Ae()), t.textTracks.length) {
      if (!y)
        for (var o = 0; o < t.textTracks.length; o++)
          t.textTracks[o].mode = "hidden";
      ye(!0);
    }
    N == null || N();
  }
  function we() {
    ne(), F == null || F();
  }
  function ne() {
    var t = n == null ? void 0 : n.current, o = t == null ? void 0 : t.buffered, l = t.duration, u = t.currentTime, i = 0, p = 0;
    try {
      for (; !(o.start(i) <= u && u <= o.end(i)); )
        i += 1;
      p = o.end(i);
    } catch {
      return X(0);
    }
    X(Math.ceil(p / l * 100));
  }
  function Te() {
    ne(), D == null || D();
  }
  function re(t) {
    var o = parseFloat(t.target.value), l = n == null ? void 0 : n.current;
    l.muted = !1, Y(o), l.volume = o, ie(o, t.target);
  }
  function ie(t, o) {
    var l = t * 100, u = "#fff", i = "rgba(255, 255, 255, 0.3)";
    o.style.background = "linear-gradient(to right, " + u + ` 0%,
      ` + u + " " + l + "%, " + i + " " + l + "%, " + i + " 100%)";
  }
  function Se() {
    be(g);
    var t = n == null ? void 0 : n.current;
    t.muted = !t.muted, Y(t.muted ? 0 : ee), ie(t.muted ? 0 : ee, R == null ? void 0 : R.current);
  }
  function ke() {
    var t = S == null ? void 0 : S.current;
    document.fullscreenElement ? document.exitFullscreen() : t.requestFullscreen();
  }
  function Re() {
    T(!0);
    var t = n == null ? void 0 : n.current, o = setInterval(function() {
      b(t.currentTime);
    }, 30);
    V(o), W == null || W();
  }
  function Ee() {
    T(!1), clearInterval(B), V(-1), L == null || L();
  }
  function xe() {
    var t = Math.floor(P / 60), o = Math.floor(P % 60).toString();
    return parseInt(o) < 10 && (o = "0" + o), t + ":" + o;
  }
  function Ae() {
    var t, o = n == null ? void 0 : n.current, l = (t = o == null ? void 0 : o.duration) != null ? t : 0, u = Math.floor(l / 60), i = Math.floor(l % 60).toString();
    return parseInt(i) < 10 && (i = "0" + i), u + ":" + i;
  }
  function Ie(t) {
    var o = n == null ? void 0 : n.current, l = k == null ? void 0 : k.current, u = l.offsetWidth, i = t.clientX - l.getBoundingClientRect().left, p = i / u * o.duration;
    o.currentTime = p, b(p);
  }
  function je(t) {
    var o = n == null ? void 0 : n.current, l = 1;
    if (t.code === "ArrowRight") {
      var u = Math.min(o.currentTime + l, o.duration);
      o.currentTime = u, b(u);
    } else if (t.code === "ArrowLeft") {
      var i = Math.max(o.currentTime - l, 0);
      o.currentTime = i, b(i);
    } else
      (t.code === "Space" || t.code === "Enter") && E();
  }
  function Oe(t) {
    if (q) {
      var o = n == null ? void 0 : n.current;
      y ? o.textTracks[0].mode = "hidden" : o.textTracks[0].mode = "showing", fe(!y);
    }
  }
  Fe(function() {
    return function() {
      B >= 0 && (clearInterval(B), V(-1));
    };
  }, []);
  var ze = m("progressbar", Object.assign({
    ariaValuMax: n == null || (x = n.current) == null ? void 0 : x.duration,
    ariaValuenow: P
  }, a == null ? void 0 : a.videoProgressBar)), _e = m("slider", Object.assign({
    ariaValuMax: 1,
    ariaValuenow: g
  }, a == null ? void 0 : a.volumeSlider)), Ue = m("button", Object.assign({}, a == null ? void 0 : a.volumeButton)), De = m("button", Object.assign({}, a == null ? void 0 : a.shareButton)), Me = m("button", Object.assign({}, a == null ? void 0 : a.subTitleButton)), We = m("button", Object.assign({}, a == null ? void 0 : a.fullScreenButton)), ae = {
    playButton: m("button", Object.assign({}, a == null ? void 0 : a.playButton)),
    pauseButton: m("button", Object.assign({}, a == null ? void 0 : a.pauseButton))
  };
  return /* @__PURE__ */ c(Ze, Object.assign({
    ref: S
  }, ve, pe, {
    children: [/* @__PURE__ */ r(et, {
      src: j || void 0,
      ref: n,
      onTimeUpdate: Te,
      onEnded: Ve,
      onPlay: Re,
      onClick: E,
      onPause: Ee,
      onLoadedMetadata: Ce,
      onProgress: we,
      controls: !1,
      loop: me,
      autoPlay: se,
      children: he
    }), /* @__PURE__ */ c(tt, {
      children: [/* @__PURE__ */ c(nt, Object.assign({
        onClick: Ie,
        onKeyDown: je,
        ref: k,
        tabIndex: 0
      }, ze, {
        children: [/* @__PURE__ */ r("div", {
          style: {
            width: ((A = P / (n == null || (I = n.current) == null ? void 0 : I.duration)) != null ? A : 0) * 100 + "%"
          }
        }), /* @__PURE__ */ r("div", {
          style: {
            width: Pe + "%"
          }
        })]
      })), /* @__PURE__ */ c(rt, {
        children: [/* @__PURE__ */ c(le, {
          children: [/* @__PURE__ */ r(f, Object.assign({
            onClick: E
          }, w ? ae.pauseButton : ae.playButton, {
            children: w ? /* @__PURE__ */ r(Xe, {}) : /* @__PURE__ */ r(Ge, {})
          })), /* @__PURE__ */ c(lt, {
            children: [/* @__PURE__ */ r(f, Object.assign({
              onClick: Se,
              style: {
                marginRight: h.components.videoPlayer.InlineStyles.VolumeContainerButtonElement.marginRight
              }
            }, Ue, {
              children: g === 0 ? /* @__PURE__ */ r(Qe, {}) : /* @__PURE__ */ r(Ye, {})
            })), /* @__PURE__ */ r(at, Object.assign({
              type: "range",
              min: "0",
              max: "1",
              step: "0.01",
              value: g,
              onChange: re,
              ref: R,
              onKeyDown: re
            }, _e))]
          }), /* @__PURE__ */ c(it, {
            children: [/* @__PURE__ */ r("div", {
              style: {
                minWidth: h.components.videoPlayer.InlineStyles.TimeContainer.minWidth
              },
              children: xe()
            }), /* @__PURE__ */ r("div", {
              style: {
                marginRight: h.components.videoPlayer.InlineStyles.TimeContainer.marginRight
              },
              children: "/"
            }), /* @__PURE__ */ r("div", {
              style: {
                minWidth: h.components.videoPlayer.InlineStyles.TimeContainer.minWidth
              },
              children: ge
            })]
          })]
        }), /* @__PURE__ */ c(le, {
          children: [/* @__PURE__ */ r(ot, Object.assign({
            disabled: !q,
            onClick: Oe,
            showSubtitles: y
          }, Me, {
            children: /* @__PURE__ */ r(Ke, {
              style: {
                width: h.components.videoPlayer.InlineStyles.SubtitlesButton.width,
                height: h.components.videoPlayer.InlineStyles.SubtitlesButton.height
              }
            })
          })), /* @__PURE__ */ r(f, Object.assign({
            disabled: !0
          }, De, {
            children: /* @__PURE__ */ r(Je, {})
          })), /* @__PURE__ */ r(f, Object.assign({
            onClick: ke,
            style: {
              marginRight: h.components.videoPlayer.InlineStyles.FullScreenButtonElement.marginRight
            }
          }, We, {
            children: /* @__PURE__ */ r(qe, {})
          }))]
        })]
      })]
    })]
  }));
}
export {
  io as VideoPlayer
};
